var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("ValidationAlert", {
        attrs: { "error-list": _vm.errors.collect("server") },
      }),
      _vm._v(" "),
      _c(
        "fieldset",
        { staticClass: "form__group" },
        [
          _c("legend", [_vm._v("Create the Lead User")]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.firstName,
                  expression: "formData.firstName",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "first-name",
                required: "",
                placeholder: "Enter the user's first name...",
              },
              domProps: { value: _vm.formData.firstName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "firstName", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "first-name" } },
              [_vm._v("First name")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__validation" }, [
              _vm._v(_vm._s(_vm.errors.first("firstName"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.surname,
                  expression: "formData.surname",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "surname",
                required: "",
                placeholder: "Enter the user's surname...",
              },
              domProps: { value: _vm.formData.surname },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "surname", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "surname" } },
              [_vm._v("Surname")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__validation" }, [
              _vm._v(_vm._s(_vm.errors.first("surname"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.position,
                  expression: "formData.position",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "position",
                required: "",
                placeholder: "Enter the user's job title...",
              },
              domProps: { value: _vm.formData.position },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "position", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "position" } },
              [_vm._v("Position")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__validation" }, [
              _vm._v(_vm._s(_vm.errors.first("position"))),
            ]),
          ]),
          _vm._v(" "),
          _c("FormControlSector", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: {
              label: "Sector specialisations",
              name: "specialisms",
              multiple: true,
            },
            model: {
              value: _vm.formData.specialisms,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "specialisms", $$v)
              },
              expression: "formData.specialisms",
            },
          }),
          _vm._v(" "),
          _c("FileUpload", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: { id: "avatar", label: "Profile picture", name: "avatar" },
            model: {
              value: _vm.formData.avatar,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "avatar", $$v)
              },
              expression: "formData.avatar",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form__group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.email,
                  expression: "formData.email",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form__control",
              attrs: {
                id: "email",
                required: "",
                placeholder: "Enter the user's email address...",
              },
              domProps: { value: _vm.formData.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.formData, "email", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form__label", attrs: { for: "email" } },
              [_vm._v("Email address")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__validation" }, [
              _vm._v(_vm._s(_vm.errors.first("email"))),
            ]),
          ]),
          _vm._v(" "),
          _c("FormControlOffice", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: {
              label: "Office location",
              placeholder: "Select one of the company's offices",
              member: this.id,
              name: "office",
            },
            model: {
              value: _vm.formData.office,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "office", $$v)
              },
              expression: "formData.office",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form__group form__group--submit" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: ["submit", "avatar uploading"],
                    expression: '["submit", "avatar uploading"]',
                    arg: "disabled",
                  },
                ],
                staticClass: "btn",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.back.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Back")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: ["submit", "avatar uploading"],
                    expression: '["submit", "avatar uploading"]',
                    arg: "disabled",
                  },
                ],
                staticClass: "btn btn--primary",
              },
              [_vm._v("Create User")]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }